import readTextFile from "./readTextFile";
import appendSeabirdMeta from "./appendSeabirdMeta";
import { apiPost, apiPostFile } from "./api";
import { workareaURLStyle } from "./workarea";
import { organizationURLStyle } from "./organization";

export function isSeabird(file) {
  return /^\s*(?:Copy of )?SBE(19plus|25|25plus)_\d{4,8}_\d{4}_\d{2}_\d{2}_\d{4}(?:_\d{4})?(?:\s\(\d+\))?(?:\.hex)?(?:\s\d+)?$/.test(
    file.name || file
  );
}

// texted capturing SBE19plus_01907674_2018_10_03_0001.hex SBE19plus_01907674_2018_10_03_0001_0001.hex SBE19plus_01907674_2018_10_03_0001 (1).hex
export function getSeabirdFilename(file) {
  const searchRgx = /(SBE(19plus|25|25plus)_\d{4,8}_\d{4}_\d{2}_\d{2}_\d{4}(?:_\d{4})?)(?:.*\.)(\w{3})/g;
  const result = searchRgx.exec(file.name);
  return { filename: result[1], ext: result[3] };
}

export const handleSeabirdFileUpload = (file, workarea, organization) => {
  const { filename } = getSeabirdFilename(file);

  // read file and append metadata
  return readTextFile(file)
    .then(t =>
      appendSeabirdMeta(t, { Workarea: workarea, Organization: organization })
    )
    .then(fileData =>
      apiPostFile(
        `/ctd/upload/seabird/${workareaURLStyle(
          workarea
        )}/${filename}?organization=${organizationURLStyle(organization)}`,
        fileData
      )
    )
    .then(res => res.json());
};

// Handle Seabird annotate
export const handleSeabirdAnnotation = (casts, workarea, organization) =>
  apiPost(
    `/ctd/annotate/seabird/${workareaURLStyle(workarea)}/casts`,
    casts.map(cast => ({
      ctd_cast_pk: cast.ctdCastPk,
      workarea: cast.workArea,
      cruise: cast.matchedForm.survey,
      station: cast.matchedForm.siteId,
      cast_number: cast.matchedForm.drop,
      status: cast.matchedForm.miscast ? "MISCAST" : undefined,
      latitude: cast.matchedForm.dropLat,
      longitude: cast.matchedForm.dropLong,
      target_depth: cast.matchedForm.targetDepthM,
      vessel: cast.matchedForm.vessel,
      operators: cast.matchedForm.fieldStaff,
      comments: cast.matchedForm.qualityLog,
      form_hakai_id: cast.matchedForm.hakaiId,
      organization: cast.matchedForm.organization || organization
    }))
  );
